import { updateShiftForm } from "../reducer";

export const DATE_FORMAT = "DD/MM/YYYY";

// Map dispatch to props<handleShiftUpdate>
export const mapDispatchToProps = dispatch => ({
  handleShiftUpdate: update => {
    dispatch((_, getState) => {
      const {
        scheduler: { shiftForm }
      } = getState();
      const shift = shiftForm.shifts[shiftForm.shiftOpenIndex] || {};
      const shifts = [...shiftForm.shifts];
      shifts[shiftForm.shiftOpenIndex] = {
        ...shift,
        ...update
      };

      dispatch(
        updateShiftForm({
          shifts
        })
      );
    });
  }
});

export const mapStateToProps = ({
  scheduler: { shiftForm, isGridSelectedShift, bonuses }
}) => ({
  shiftOpenIndex: shiftForm.shiftOpenIndex,
  isGridSelectedShift,
  shiftForm,
  bonuses
});
